import React, { useState } from "react";
import "../Header.css";
import logo from "../../assets/visionvotelogo-2.png";
import { FiSend } from "react-icons/fi";
import { NavLink } from "react-router-dom";

const Header = () => {
    const [open, setOpen] = useState(false);

    const closeMenu = () => setOpen(false);

    const getLinkClass = ({ isActive }) =>
        isActive ? "nav-link active-link" : "nav-link";

    return (
        <header className="header">
            <div className="header-container">

                <div className="logo">
                    <NavLink to="/" onClick={closeMenu}>
                        <img
                            src={logo}
                            alt="VisionVote Technologies"
                            className="logo-img"
                        />
                    </NavLink>

                    <NavLink to="/" className="logo-text" onClick={closeMenu}>
                        VISIONVOTE TECHNOLOGIES
                    </NavLink>
                </div>

                <nav className={`nav ${open ? "active" : ""}`}>
                    <NavLink to="/" className={getLinkClass} onClick={closeMenu}>
                        Home
                    </NavLink>

                    <NavLink to="/company" className={getLinkClass} onClick={closeMenu}>
                        Company
                    </NavLink>

                    <NavLink to="/services" className={getLinkClass} onClick={closeMenu}>
                        Services
                    </NavLink>

                    <NavLink to="/industries" className={getLinkClass} onClick={closeMenu}>
                        Industries
                    </NavLink>

                    <NavLink to="/contact" className={getLinkClass} onClick={closeMenu}>
                        Contact Us
                    </NavLink>

                    {/* <NavLink
                        to="/get-proposal"
                        className="cta-btn"
                        onClick={closeMenu}
                    >
                        <FiSend className="cta-icon" />
                        Get Quote
                    </NavLink> */}
                </nav>

                <div
                    className={`hamburger ${open ? "open" : ""}`}
                    onClick={() => setOpen(!open)}
                >
                    <span />
                    <span />
                    <span />
                </div>

            </div>
        </header>
    );
};

export default Header;